import type { LDClient } from 'launchdarkly-js-client-sdk';
import type { FlagKeys } from '@/common/providers/featureFlagProvider';
import { isDevToolsEnabled } from './dev-tools/isDevToolsEnabled';

interface LiveFlagContext {
  flagOverrides: Partial<FlagKeys>;
  flags: Partial<FlagKeys>;
  ldClient: LDClient | undefined;
}

export function readLiveFlag<K extends keyof FlagKeys>(
  { flagOverrides, flags, ldClient }: LiveFlagContext,
  key: K,
): FlagKeys[K] | undefined {
  const override = isDevToolsEnabled() ? flagOverrides[key] : undefined;
  return override ?? ldClient?.variation(key, flags[key]) ?? flags[key];
}
